export default {
  teamTitle: 'Join our team',
  teamText: `We cultivate excellence,\njust as we do with our yeasts.`,
  info: `Via Verdi,\n32 31046 Oderzo - TV\nItaly`,
}
